import ApiService from '@/app/framework/services/ApiServices'
import { Endpoints } from '@/app/framework/misc/Endpoints'
import { injectable } from 'tsyringe'
import { BulletinReportRepositoryInterface } from '@/data/persistences/repositories/contracts/BulletinReportRepositoryInteface'
import { BulletinReport, Export } from '@/domain/entities/BulletinReport'
import { BulletinReportDataMapper } from '@/data/persistences/mappers/BulletinReportDataMapper'

@injectable()
export class BulletinReportApiRepository
  implements BulletinReportRepositoryInterface {
  private service: ApiService
  private mapper: BulletinReportDataMapper

  constructor(service: ApiService, mapper: BulletinReportDataMapper) {
    this.service = service
    this.mapper = mapper
  }

  public async getAll(params: Object): Promise<BulletinReport> {
    const resp = await this.service.invoke(
      'get',
      Endpoints.Route.REPORT_BULLETIN,
      params
    )
    return this.mapper.convertBulletinReportFromApi(resp)
  }
  public async getExport(params: Object): Promise<Export> {
    const resp = await this.service.invoke(
      'get',
      Endpoints.Route.EXPORT_BULLETIN,
      params
    )
    return this.mapper.convertExportFileFromAPi(resp)
  }
}
